<template>
  <div class="empty">
    <img :src="img" alt="" />
    <p>{{ desc }}</p>
    <button v-show="haveButton" class="btn" @click="handleClick">
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      // 空状态图片
      img: {
        type: String,
        default: require("@/assets/images/icons/icon_warning.png"),
      },
      // 描述文字
      desc: {
        type: String,
        default: "什么都没有找到呢~",
      },
      // 是否有按钮
      haveButton: {
        type: Boolean,
        default: false,
      },
      // 按钮文字
      buttonText: {
        type: String,
        default: "按钮文字",
      },
    },
    methods: {
      // 抛出按钮事件
      handleClick() {
        this.$emit('btnClick')
      }
    }
  };
</script>

<style lang="less" scoped>
  .empty {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    padding: 90px 0;
    height: auto !important;
    min-height: auto !important;
    // transform: translate(-50%, -50%);
    text-align: center;

    img {
      width: 100px;
    }
    
    p {
      margin-top: 30px;
      font-size: 20px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      text-align: center;
    }

    .btn {
      margin-top: 40px;
      width: 160px;
      height: 45px;
      color: #fff;
      background: #1976f5;
      font-size: 20px;
    }
  }
</style>